"use client";

import { c as _c } from "react/compiler-runtime";
import { useSearchqueryState } from "@repo/design-system/hooks/use-searchquery-state";
import { cn } from "@repo/design-system/utils/cn";
import { XIcon } from "lucide-react";
import { ComboboxFloatingLabel } from "~/components/ui/combobox-eon";
import { useLanguage } from "~/translations/loader/use-language";
export function SearchbarHungary(t0) {
  const $ = _c(22);
  const {
    className
  } = t0;
  const [search, setSearch] = useSearchqueryState();
  const t = useLanguage();
  const floating = !!search;
  let t1;
  if ($[0] !== className) {
    t1 = cn("relative", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== floating || $[3] !== t.filterbar_searchLabel) {
    t2 = <ComboboxFloatingLabel floating={floating} htmlFor="search">{t.filterbar_searchLabel}</ComboboxFloatingLabel>;
    $[2] = floating;
    $[3] = t.filterbar_searchLabel;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== setSearch) {
    t3 = e => setSearch(e.target.value || null);
    $[5] = setSearch;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = floating ? t.filterbar_filter1_placeholder_search : "";
  const t5 = search || "";
  let t6;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t6 = <input autoComplete="off" className="h-10 min-w-[60px] flex-1 bg-transparent px-3 text-white outline-none placeholder:text-white" id="search" onChange={t3} placeholder={t4} type="text" value={t5} />;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== search || $[12] !== setSearch || $[13] !== t.filterbar_titleClear) {
    t7 = search && <button aria-label={t.filterbar_titleClear} className="mr-2 flex items-center justify-center rounded p-1 text-white opacity-70 hover:opacity-100" onClick={async () => setSearch(null)} type="button"><XIcon className="size-4" /></button>;
    $[11] = search;
    $[12] = setSearch;
    $[13] = t.filterbar_titleClear;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className="flex min-h-12 w-full items-center rounded-lg border border-white bg-transparent transition-colors">{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t1 || $[19] !== t2 || $[20] !== t8) {
    t9 = <div className={t1}>{t2}{t8}</div>;
    $[18] = t1;
    $[19] = t2;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}